import axios from 'axios';
import { addUsersToSharedFileQuery } from './queries';
import Split from '../split';
import { buildExpressQuery, buildLoopbackQuery } from './queries/builders';

const addUsersToSharedFile = async (fileName, usersToAdd) => {
    const useExpressMigration = Split.getBooleanTreatment('use_express_migration_endpoints');
    const queryBuilder = useExpressMigration ? buildExpressQuery : buildLoopbackQuery;
    const body = {
        generated_name: fileName,
        sentTo_ids: usersToAdd.map((user) => user.id),
    };

    const query = addUsersToSharedFileQuery({ queryBuilder });
    const resp = await axios.patch(query, body);

    return resp.data;
};

export default addUsersToSharedFile;
